class DateParts {
    constructor(model) {
        this.Year = model.Year;
        this.Month = model.Month;
        this.Day = model.Day;
        this.Hours = model.Hours;
        this.Minutes = model.Minutes;
        this.Seconds = model.Seconds;
        this.FormattedDate = model.FormattedDate;
        this.Date = this.getDate();
    }
    getDate() {
        return new Date(this.Year, this.Month, this.Day, this.Hours, this.Minutes, this.Seconds);
    }
    getDateWithoutTime() {
        return new Date(this.Year, this.Month, this.Day);
    }
    static CreateFromDate(date) {
        var dateParts = new DateParts({
            Year: date.getFullYear(),
            Month: date.getMonth(),
            Day: date.getDate(),
            Hours: date.getHours(),
            Minutes: date.getMinutes(),
            Seconds: date.getSeconds(),
            FormattedDate: (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
        });
        return dateParts;
    }
    static CreateFromTimestamp(timestamp) {
        var date = new Date();
        date.setTime(timestamp);
        return this.CreateFromDate(date);
    }
    getTime() {
        return this.Date.getTime();
    }
    getSpanBetweenDates(other, datePrecision) {
        var difference = this.getTime() - other.getTime();
        var divisor;
        if (datePrecision == DatePrecision.Day)
            divisor = DateParts.OneDay;
        else if (datePrecision == DatePrecision.Month)
            divisor = DateParts.OneMonth;
        return Math.round(Math.abs(difference / divisor));
    }
    static getDateFromOffset(startDate, offset, datePrecision) {
        var date = new Date(startDate.getTime());
        if (datePrecision == DatePrecision.Day)
            date.setDate(date.getDate() + offset);
        else if (datePrecision == DatePrecision.Month)
            date.setMonth(date.getMonth() + offset);
        return date;
    }
    getFormattedDate() {
        return '{0} {1}, {2}'.format(this.getMonthName(), this.Day, this.Year);
    }
    getFormattedTime() {
        var hour = this.Hours > 12 ? this.Hours - 12 : this.Hours;
        var minute = this.Minutes < 10 ? '0' + this.Minutes : this.Minutes.toString();
        var period = this.Hours > 11 ? 'pm' : 'am';
        return '{0}:{1} {2}'.format(hour, minute, period);
    }
    getWeekday() {
        return DateParts.WeekNames[this.getDate().getDay()];
    }
    getMonthName() {
        return DateParts.MonthNames[this.Month];
    }
}
DateParts.OneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
DateParts.OneMonth = 30 * DateParts.OneDay; // days * OneDay
DateParts.MonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
DateParts.WeekNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var DatePrecision;
(function (DatePrecision) {
    DatePrecision[DatePrecision["Day"] = 0] = "Day";
    DatePrecision[DatePrecision["Month"] = 1] = "Month";
})(DatePrecision || (DatePrecision = {}));
//# sourceMappingURL=DateParts.js.map